export const ALL_AGES_CONTENT_AGE_RANGE = 121;

export const isAllAgesContentAgeRange = (ageRange) =>
  Number(ageRange) === ALL_AGES_CONTENT_AGE_RANGE;

const hasAgeRangeValue = (ageRange) =>
  ageRange !== null && ageRange !== undefined && ageRange !== "";

export const getContentAgeRangeValue = (item) => {
  if (!item || typeof item !== "object") return undefined;

  const ranges = [
    item?.content?.ageRange,
    item?.content?.contentAgeRange,
    item?.contentMeta?.content?.ageRange,
    item?.contentMeta?.content?.contentAgeRange,
    item?.rawData?.ageRange,
    item?.rawData?.contentAgeRange,
    item?.ageRange,
    item?.contentAgeRange,
  ];

  return ranges.find(hasAgeRangeValue);
};

export const isContentAllowedForAgeRange = (
  contentAgeRange,
  userAgeRange,
  { allowEmpty = true } = {}
) => {
  if (
    contentAgeRange === null ||
    contentAgeRange === undefined ||
    contentAgeRange === ""
  ) {
    return allowEmpty;
  }

  if (isAllAgesContentAgeRange(contentAgeRange)) {
    return true;
  }

  const normalizedContentAgeRange = Number(contentAgeRange);
  const normalizedUserAgeRange = Number(userAgeRange || 120);

  if (Number.isNaN(normalizedContentAgeRange)) {
    return allowEmpty;
  }

  if (Number.isNaN(normalizedUserAgeRange) || !normalizedUserAgeRange) {
    return false;
  }

  return normalizedContentAgeRange <= normalizedUserAgeRange;
};

export const isContentBlockedByAgeRange = (contentAgeRange, userAgeRange) =>
  !isContentAllowedForAgeRange(contentAgeRange, userAgeRange);

export const isContentItemAllowedForAgeRange = (
  item,
  userAgeRange,
  options
) => isContentAllowedForAgeRange(getContentAgeRangeValue(item), userAgeRange, options);

export const isContentItemBlockedByAgeRange = (item, userAgeRange) =>
  !isContentItemAllowedForAgeRange(item, userAgeRange);
